import LoggingBase from '../../../../base/loggingbase';
import Validator from '../../../../utils/Validator';

/**
 * class XRowItemHeightAdjustmentExtension - reads/writes the height of a row item's model
 * item ({@link XRowItem}). It is a plain delegate: the host row item is passed in and
 * accessed via {@link #host}.
 */
export default class XRowItemHeightAdjustmentExtension extends LoggingBase {

	/**
	 * constructs a new instance
	 * @param {*} host the host row item (XRowItem)
	 */
	constructor( host ) {
		super( 'widgets.xtw.rowheight.XRowItemHeightAdjustmentExtension' );
		this._host = host;
	}

	/**
	 * @returns {*} the host row item
	 */
	get host() {
		return this._host;
	}

	/**
	 * @override
	 */
	doDestroy() {
		this._host = void 0;
		super.doDestroy();
	}

	get height() {
		const modelItem = this.host.item;
		if ( !Validator.isObject( modelItem ) ) {
			return void 0;
		}
		return Validator.isFunction( modelItem.getHeight ) ? modelItem.getHeight() :
			"height" in modelItem ? modelItem.height : void 0;
	}

	set height( newValue ) {
		let newHeightValue = newValue;
		if ( Validator.isString( newHeightValue ) ) {
			newHeightValue = Number( newHeightValue );
		}
		if ( !Validator.isPositiveNumber( newHeightValue ) ) {
			return;
		}
		const modelItem = this.host.item;
		if ( !Validator.isObject( modelItem ) || !( "height" in modelItem ) ) {
			return;
		}
		modelItem.height = newHeightValue;
	}

}
